import $ from 'jquery';

class Events {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$socialLinks = $('.js-footer-link');
        this.addClickHandlers();
    }

    addClickHandlers() {
        this.$socialLinks.on('click', e => {
            this.handleEventTracking(
                e.currentTarget.dataset.category,
                e.currentTarget.dataset.label
            );
        });
    }

    handleEventTracking(category, label, value) {
        console.log(`category: ${category}\nlabel: ${label}`);
        gtag('event', 'click', {
            event_category: category,
            event_label: label,
        });
        console.log('Data Layer:', window.dataLayer);
    }

    static init() {
        new Events();
    }
}

export default Events;
